/**资源管理模块 */
import request from '../request/http';
/**分页查询资源数据 */
export function PageResourceList(data){
    return request({
        url: '/sp/resourceData/pageList',
        method: 'post',
        data
    })
}
/**主体资源绑定资源 */
export function MainBindData(data){
    return request({
        url: '/sp/resourceData/mainBindData',
        method: 'post',
        data
    })
}
/**资源预览 */
export function ResourcePreview(data){
    return request({
        url: '/sp/resourceData/resourcePreview',
        method: 'post',
        data
    })
}
/**查询主体资源已绑定资源 */
export function GetBindData(data){
    return request({
        url: '/sp/resourceData/getBindData',
        method: 'post',
        data
    })
}
/**主体资源解绑资源 */
export function MainUnbindData(data){
    return request({
        url: '/sp/resourceData/mainUnbindData',
        method: 'post',
        data
    })
}
/**修改资源 */
export function UpdateResource(data){
    return request({
        url: '/sp/resourceData/updateResource',
        method: 'post',
        data
    })
}
/**删除资源 */
export function DelResource(data){
    return request({
        url: '/sp/resourceData/delResource',
        method: 'post',
        data
    })
}
/**新增资源 */
export function AddResource(data){
    return request({
        url: '/sp/resourceData/addResource',
        method: 'post',
        data
    })
}
/**共享资源 */
export function ShareResData(data){
    return request({
        url: '/sp/resourceData/shareResData',
        method: 'post',
        data
    })
}
/**查询主体资源绑定节点 */
export function QueryResDataNode(data){
    return request({
        url: '/sp/resourceData/queryResDataNode',
        method: 'post',
        data
    })
}
/**查询资源详情 */
export function QueryResDataDetail(data){
    return request({
        url: '/sp/resourceData/queryResDataDetail',
        method: 'post',
        data
    })
}
/**分页查询我收藏的资源 */
export function PageMyCollectList(data){
    return request({
        url: '/sp/resourceData/pageMyCollectList',
        method: 'post',
        data
    })
}
/**取消资源共享 */
export function CancelShareResData(data){
    return request({
        url: '/sp/resourceData/cancelShareResData',
        method: 'post',
        data
    })
}
/**获取数据类型资源数量 */
export function GetDataTypeResDataCount(data){
    return request({
        url: '/sp/resourceData/getDataTypeResDataCount',
        method: 'post',
        data
    })
}
/**根据课程id获取所有已绑定资源 */
export function GetAllBindData(data){
    return request({
        url: '/sp/resourceData/getAllBindData',
        method: 'post',
        data
    })
}